<template>
  <section class="mb-4">
    <section-title id="employees">{{
      $t("team-page-agency-account-managers-title")
    }}</section-title>
    <div class="row">
      <div class="col-xs-12 col-md-6 col-lg-4" v-for="(cdc, i) in cdc" :key="i">
        <b-card class="shadow mt-3">
          <div class="text-center">
            <b-img
              slot="aside"
              :src="imgSrc + cdc.pk + '.jpg'"
              width="128"
              height="128"
              class="rounded-circle"
              :alt="cdc.fullName"
              @error.prevent.once="loadAvatar(cdc, $event)"
            />
            <h3 class="mb-1">{{ cdc.fullName }}</h3>

            <p class="text-muted mb-1">
              <span v-if="cdc.gender == 1">
                <span v-if="cdc.isMainCDC">{{
                  $t("team-page-agency-my-account-manager-male")
                }}</span>
                <span v-else>{{ $t("team-page-agency-account-manager") }}</span>
              </span>
              <span v-else>
                <span v-if="cdc.isMainCDC">{{
                  $t("team-page-agency-my-account-manager-female")
                }}</span>
                <span v-else>{{ $t("team-page-agency-account-manager") }}</span>
              </span>
            </p>

            <p class="mb-0">
              <a :href="'mailto:' + cdc.emailPro">{{ cdc.emailPro }}</a>
            </p>

            <div v-if="cdc.isMainCDC">
              <b-button
                v-if="cdc.telPro || cdc.telAntenne"
                :href="'tel:' + cdc.telAntenne"
                variant="outline-primary"
                size="sm"
                class="m-3"
              >
                <svgicon
                  icon="phone"
                  class="mr-1"
                  width="17"
                  height="17"
                ></svgicon>
                <strong v-if="cdc.telPro">{{
                  cdc.telPro | formatPhone
                }}</strong>
                <strong v-else-if="cdc.telAntenne">{{
                  cdc.telAntenne | formatPhone
                }}</strong>
              </b-button>
            </div>
          </div>
        </b-card>
      </div>

      <b-card v-if="!isLoading && cdc.length == 0">
        <b-media>{{ $t("team-page-agency-account-manager-no-data") }}</b-media>
      </b-card>

      <b-card v-if="isLoading && cdc.length == 0" class="mb-3">
        <h3 slot="header" class="h6 m-0 text-muted">
          {{ $t("team-page-agency-customer-service-representative") }}
        </h3>
        <b-media class="text-center">
          <spinner height="128" width="128"></spinner>
        </b-media>
      </b-card>

      <b-card v-if="error" class="mb-3">
        <b-media v-html="$t('team-page-agency-account-manager-data-error')">
        </b-media>
      </b-card>
    </div>
    <!-- <vita-cdc-collegues></vita-cdc-collegues> -->
  </section>
</template>

<script>
import SectionTitle from "../../SectionTitle.vue";
import Spinner from "../../Helpers/Spinner/Spinner.vue";
import vitacenterImgSrc from "../../Mixins/VitacenterImgSrc";
import fallbackToAvatar from "../../Mixins/fallbackToAvatar.js";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    SectionTitle,
    Spinner
  },
  data() {
    return {
      cdc: {},
      error: false
    };
  },
  mixins: [fallbackToAvatar, vitacenterImgSrc],
  computed: {
    ...mapGetters("cdc", ["autresCdcData", "autresCdcError"]),
    ...mapGetters(["isLoading"])
  },
  watch: {
    autresCdcData(newData) {
      this.cdc = newData;
    },
    autresCdcError() {
      this.error = true;
    }
  },
  created() {
    this.load();
  },
  methods: {
    ...mapActions("cdc", ["loadAutresCDCs"]),
    load() {
      // this.loadCDC()
      if (this.autresCdcData) {
        this.cdc = this.autresCdcData;
      } else {
        this.loadAutresCDCs();
      }
    }
  }
};
</script>

<style></style>
